import React from 'react';
import styled from 'styled-components';
import routes, { redirects } from './routes';
import DashboardTemplate from '../../common/DashboardTemplate';
import { withTranslation } from 'components/hoc';
import RouteRedirect from '../../common/RouteRedirect';

const Wrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 90%;
  margin: 1% auto auto 3.7%;
`;

const Admin = (props) => {
  return (
    <DashboardTemplate
      {...props}
      showSubmenu={true}
      routes={routes}
      redirects={redirects}
      render={(renderPropsData) => (
        <Wrapper>
          <RouteRedirect {...renderPropsData} />
        </Wrapper>
      )}
    />
  );
};

export default withTranslation(Admin);
